import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OrderDetailResponse } from "../interfaces/detail-order.interface";
import { Observable } from "rxjs";
import { AuthService } from "../../../../core/service/auth.service";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class OrderDetailService {
  constructor(private http: HttpClient,
    private authservice: AuthService,
  ) { }

  getOrderDetails(orderId: number): Observable<OrderDetailResponse> {
    const token = this.authservice.getToken();
    if (!token) {
      throw new Error('No authenticated user');
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<OrderDetailResponse>(
      `${environment.apiUrl}/orders/details/${orderId}`,
      { headers }
    );
  }
}